export default class HomeHeroCover {
    constructor({ el, title }) {
        this.el = el
        this.title = title
        document.body.style.setProperty("overflow", "hidden")

        // Pristine headline markup: restored once the intro is over so the
        // headline wraps like normal text again (the split lines were fixed
        // boxes that wrapped word by word when the window got narrower).
        this.originalHTML = this.title.innerHTML

        this.split = new SplitText(this.title, {
            type: "lines, words",
        });

        this.callToAction = this.el.querySelector(".wp-block-cinetic-creatives-blocks-call-to-action")

        gsap.to(this.callToAction, {
            autoAlpha: 1
        })

        this.top = this.split.lines.slice(0, this.split.lines.length / 2);
        this.bottom = this.split.lines.slice(this.split.lines.length / 2 + 1, this.split.lines.length);
        this.middle = this.split.lines[Math.floor(this.split.lines.length/ 2)]

        gsap.set(this.top, {
            y: `-50svh`
        })
        gsap.set(this.bottom, {
            y: `50svh`
        })
        this.bottomChars = new SplitText(this.middle, {
            type: "chars",
        });

        let closestIndex = -1;
        let minDistance = Infinity;
        let signedDistance = 0
        let collisionData = {
            index: -1,
            distance: 0,
            isColliding: false,
            side: null // "left" or "right"
        };

        const screenCenterX = window.innerWidth / 2

        this.bottomChars.chars.forEach((char, index) => {
            const rect = char.getBoundingClientRect();
            
            const distance = screenCenterX - rect.left

            if (Math.abs(distance) < minDistance) {
                minDistance = Math.abs(distance)
                signedDistance = distance
                closestIndex = index
            }
            
        });


        this.left = this.bottomChars.chars.slice(0, closestIndex);
        this.right = this.bottomChars.chars.slice(closestIndex , this.bottomChars.chars.length);
        
        gsap.set(this.left, {
            x: -(window.innerWidth * 0.5 + signedDistance)
        })
        gsap.set(this.right, {
            x: (window.innerWidth * 0.5 + signedDistance)
        })

        this.signedDistance = signedDistance
        this.offsetY = this.middle.offsetHeight * 0.5
        // console.log()

        this.boundedClick = this.handleClick.bind(this)
        this.callToAction.addEventListener("click", this.boundedClick)

        const video = el.querySelector("video")
        video.addEventListener("ended", this.boundedClick)

        // Autoplay is not guaranteed (Low Power Mode, some Safari reloads).
        // Ask explicitly: a refused play() ends the intro at once instead of
        // leaving the poster frame on screen. A slow connection gets 15 s to
        // show the first frame before the intro gives up as well.
        video.play().catch(() => this.handleClick())
        this.watchdog = window.setTimeout(() => {
            if (this.closing || !document.body.contains(this.el)) return
            if (video.currentTime < 0.2) {
                this.handleClick()
            }
        }, 15000)

        // "Skip intro" is visible from the first paint (markup in functions.php);
        // a tap that happened before this script booted is honoured here.
        if (window.cineticSkipIntro) {
            this.handleClick()
        }
    }

    handleClick () {
        if (this.closing) return
        this.closing = true
        window.clearTimeout(this.watchdog)
        this.callToAction.removeEventListener("click", this.boundedClick)
        const timeline = new gsap.timeline({

            onComplete: () => {
                document.body.removeChild(this.el)
                document.body.style.removeProperty("overflow")
                this.restoreTitle()
                // Removing the cover also lifts the CSS scroll lock (functions.php).
                window.dispatchEvent(new Event("resize"))
                ScrollTrigger.refresh()
            }
        })
        timeline.set(window, { scrollTo: 0 })
        timeline.to(this.callToAction, {
            autoAlpha: 0,
        }, 'a')
        timeline.to(this.el.querySelector(".controls"), {
            autoAlpha: 0,
        }, 'a')
        const duration = 2
        const ease = "power2.inOut"
        timeline.to(this.el.querySelector("video"), {
            scale: 0,
            y: this.offsetY,
            x: -this.signedDistance,
            duration,
            ease
        }, 'a')

        .to(this.top, {
            y: `0svh`,
            duration,
            ease
        }, 'a')
        .to(this.bottom, {
            y: `0svh`,
            duration,
            ease
        }, 'a')
        .to(this.left, {
            x: `0svw`,
            duration,
            ease
        }, 'a')
        .to(this.right, {
            x: `0svw`,
            duration,
            ease
        }, 'a')
        
    }

    restoreTitle() {
        if (this.restored) return
        this.restored = true
        this.bottomChars?.revert()
        this.split?.revert()
        this.title.innerHTML = this.originalHTML
        // Lets the Title component take over (line breaks on phones, resizes).
        this.title.dispatchEvent(new CustomEvent("cinetic:hero-done"))
    }

    handleResize() {

    }

    dispose() {
    }
}